import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  standalone: false,
  selector: "formly-field-timepicker",
  templateUrl: "./timepicker.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFieldTimepicker extends FieldType<FieldTypeConfig> {

  override defaultOptions = {
    props: {
      format: 'h:mm a',
      steps: {
        hour: 1,
        minute: 5,
      }
    }
  };

  onChange(value: Date): void {
    if (this.props.change) {
      this.props.change(this.field, value);
    }
  }

}
